// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"454d7d35","453":"92905c45","455":"cd5a3ea7"}[chunkId] + ".chunk.js";
};